module.exports = __webpack_public_path__ + "img/usuario_chat.aa447c1e.svg";